// Vergleich Medienmaße vs. Zielfläche des Geräts (Heartbeat-Auflösung, bei
// rotation 90/270 vertauscht). Regeln gemäß ANWEISUNG_AUFLOESUNG.md:
// exakt passende Medien erzeugen keine Meldung, jede Meldung nennt die Zielgröße.
export function fitHints(media, screen) {
  const mw = media.width || 0;
  const mh = media.height || 0;
  let sw = screen.sw || 0;
  let sh = screen.sh || 0;
  if (!(sw > 0 && sh > 0) || !(mw > 0 && mh > 0)) return [];
  if (screen.rotation === 90 || screen.rotation === 270) {
    [sw, sh] = [sh, sw];
  }
  const out = [];
  const rec = `Empfohlen: ${sw} × ${sh}`;
  const ma = mw / mh;
  const ta = sw / sh;
  if (Math.abs(ma - ta) / ta > 0.01) {
    out.push({
      level: "warn",
      text: `Seitenverhältnis passt nicht — schwarze Balken ${ma < ta ? "links/rechts" : "oben/unten"}. ${rec}`,
    });
  }
  if (mw < 0.5 * sw) {
    out.push({ level: "error", text: `Deutlich zu klein (${mw} × ${mh}). ${rec}` });
  } else if (mw < 0.8 * sw) {
    out.push({ level: "warn", text: `Wird unscharf hochskaliert (${mw} × ${mh}). ${rec}` });
  }
  if (mw > 1.5 * sw) {
    out.push({ level: "info", text: `Größer als nötig (${mw} × ${mh}) — kostet Bandbreite und Cache. ${rec}` });
  }
  if ((media.mime || "").startsWith("video/") && mw > 1920) {
    out.push({ level: "warn", text: "Video breiter als 1920 px — der Pi 4 dekodiert H.264 nur bis 1080p in Hardware, darüber ruckelt es" });
  }
  return out;
}

export const FIT_SEV = { error: 3, warn: 2, info: 1 };

export const FIT_CLS = {
  error: "border-red-500/40 bg-red-500/10 text-red-300",
  warn: "border-amber-500/40 bg-amber-500/10 text-amber-300",
  info: "border-slate-500/40 bg-slate-500/10 text-slate-300",
};

export const FIT_LABEL = { error: "Fehler", warn: "Warnung", info: "Hinweis" };
